// extracted by mini-css-extract-plugin
export default {"noWrap":"Text_noWrap__lXK89","block":"Text_block__7vXqe"};